import { render, staticRenderFns } from "./LeadsAdd.vue?vue&type=template&id=1b3aadfc&scoped=true&"
import script from "./LeadsAdd.vue?vue&type=script&lang=js&"
export * from "./LeadsAdd.vue?vue&type=script&lang=js&"
import style0 from "./LeadsAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LeadsAdd.vue?vue&type=style&index=1&id=1b3aadfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3aadfc",
  null
  
)

export default component.exports